<div class="container">
  <div class="loader"></div>
  <span class="loader-text">Loading...</span>
</div>
